// react
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { ROUTES, buildUrl } from 'router';

// components
import LoadingPage from '@karehero/llama/components/pages/Loading/Loading';

/**
 * TypeformSubmitted is the sign in page, and handles user authentication.
 */
export const TypeformSubmitted = () => {
  // hooks
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // effects
  useEffect(() => {
    switch (searchParams.get('utm_source')) {
      case 'karehero_typeform':
        navigate(
          buildUrl(ROUTES.REGISTER_MEMBER, { utm_source: 'karehero_typeform' }),
        );
        break;
      case 'karehero_typeform_native':
        window.location.href =
          'karehero://register/member?utm_source=karehero_typeform';
        break;
      default:
        navigate(ROUTES.HOME);
    }
  }, [searchParams]);

  return <LoadingPage />;
};

export default TypeformSubmitted;
